import {add, get, getChart, create, update, remove, initialState, getDashboardIndex, getACLCharts, getExport, download} from '@/models/chart';
import {getDataSources, buildHierachy, recommendDashboard} from '@/models/data-source';
import {createGrid} from '@/models/grid';
import {selectDataSource, sparklineSummaryGenerator} from '@/models/chart-generator/sparkline-summary.js';
import {sparklineSummaryWithoutDataGenerator} from '@/models/chart-generator/sparkline-summary-without-date.js';

import guid from '@/lib/guid';

const cleanName = (name) => name.toLowerCase().replace(/\s/g, '');

// import {cloneDeep} from 'lodash';

const _initialState = initialState();
export default {
  async aInit(context) {

    context.state.display = false;
    context.state.editable = true;
    context.state.dataSource = {};

    context.state.filters = {};
    context.state.chartType = null;
    context.state.activeGrid = {id: null};
    context.state.activeLayer = {id: null, type: null};
    context.state.loading = false;

    console.log("context.state.user", context.state.user);

    // context.state = {..._initialState};
    // console.log("context.state", context.state);
    context.commit('mSet', {});
    context.commit('mSetCharts', []);


    context.state.loading = true;

//    console.log("here 2");
    let d  = await getDataSources({projectId: context.state.projectId});
    d = d.filter(dd => !dd.parents.length);
    let dataSources = [];

    const calls = [];
    for(let i = 0; i < d.length; i++) {
      if(d[i].type == "default") {
          continue;
      }
      calls.push(async () => { 
        d[i].cacheable = true;
        await d[i].update();
        dataSources.push(d[i]);
      });
    }

    //console.log("d size", d.length);
   // console.log("calls size", calls);
    await Promise.all(calls.map(p => p())).catch(function(error) { });
  //  console.log(dataSources);
//  console.log("here 3");
//dataSources 

  // let p = 0;
  //   for(let i = 0; i < d.length; i++) {
  //     if(d[i].type == "default") {
  //       continue;
  //     }
  //     try {
  //       // console.log(d[i].name);
  //       p = p + 100/d.length;
  //       if(p > 98) {
  //         p = 95;
  //       }
  //       context.commit('mProgressValue', p);
  //       d[i].cacheable = true;
  //       await d[i].update();
  //       dataSources.push(d[i]);
  //     } catch(err) {
  //     //  console.log(err);
  //     }

  //   }
//    console.log("here 4");
    context.commit('mSetDataSources', dataSources);
//    console.log("init charts", "before");
    let charts  =  await get({projectId: context.state.projectId, typeGroup: context.state.typeGroup});
    let aclCharts = getACLCharts(context.state.user, charts);
    console.log("aclCharts", aclCharts);
    if(charts.length == 0) {
      // await context.dispatch('aAdd');
      context.commit('mInitializeGrids');
      context.commit('mStartDisplay');

      // context.commit('mSetDialog', true); // @uncomment

    } else if (charts.length) {
      // found database value
      // console.log("Found a chart");
      context.commit('mSetCharts', charts);
      const index = getDashboardIndex(context.state.user, charts);
      await context.dispatch('aSet', charts[index]);


    }

    context.commit('mProgressValue', 98);
    context.state.loading = false;
    // console.log(charts);
    // commit('mInit', charts);
  },
  async aCreateRandomDashboard(context, chart)  {
    try {
    context.commit('mLoading', true);
    if(typeof chart == "undefined") {
      const num = context.state.charts.length + 1;
      chart = create({
        projectId: context.state.projectId,
        typeGroup: context.state.typeGroup,
        name: context.state.typeGroup + ' ' + num
      });
      delete chart.id;
      chart = await add(chart);
    }


    chart.setTree(context.state);
    let dataSources  = await getDataSources({projectId: context.state.projectId});
    dataSources = dataSources.filter(dd => !dd.parents.length);
    context.commit('mSetDataSources', dataSources);


    let charts  =  [chart];
    const index = getDashboardIndex(context.state.user, charts);
    await context.dispatch('aSet', charts[index]);
    context.commit('mSetCharts', charts);

    context.commit('mProgressValue', 20);
    let dataSource = await selectDataSource(dataSources);
    context.commit('mProgressValue', 40);
    let distinctResponse= await dataSource.resultRequest("/datasource/distinct/" + dataSource.id, {rowsPerPage: 1});
    context.commit('mProgressValue', 60);
    let randomResponse = await dataSource.resultRequest("/datasource/random/" + dataSource.id, {rowsPerPage: 1000});
    context.commit('mProgressValue', 90);
/**
    console.log("distinctResponse", distinctResponse);

    console.log("randomResponse.results", randomResponse.results);
    console.log("dataSource.columnNamess", dataSource.columnNames);
    console.log("distinctResponse.results[0]", distinctResponse.results[0]);**/

    const columns = buildHierachy(randomResponse.results, dataSource.columnNames, distinctResponse.results[0]);

    console.log("recommendDashboard columns", columns);
    console.log("distinctResponse.results[0]", distinctResponse.results[0]);
    let dashboardModel = recommendDashboard(columns);
    console.log("dashboardModel", dashboardModel);

  //  await distinctResponse =

    if(dashboardModel.model == 'company-summary') {
      sparklineSummaryGenerator(chart, dataSource, dashboardModel.columns);
      await context.dispatch('aUpdate', chart);
    } else if(dashboardModel.model == 'company-summary-without-date') {
      sparklineSummaryWithoutDataGenerator(chart, dataSource, dashboardModel.columns);
      await context.dispatch('aUpdate', chart);
    }

    context.commit('mProgressValue', 100);
    // context.commit('mAdd', chart);



    /**


    await context.dispatch('aAddGrid', {h: 14});
    const size = chart.layout.grids.length;
    let grid = chart.layout.grids[size-1];
    let layer = grid.layers[0];
    layer.type = "sparkline.number";
    layer.reset();
    layer.setParameters();
    layer.loadDefaults();
    chart.loadDataSources(layer.type);
    layer.setParameters();
    layer.loadDefaults();
    layer.setTree(context.state);
    layer.loadDataSources();
    layer.loadDefaultDataSources();**/

    // mSetLayerType(chart.type); chart.loadDataSources(chart.type); mLoadActiveLayer();
    //await context.dispatch('aAddGrid', {h: 8, w: 6});
    //await context.dispatch('aAddGrid', {h: 8, w: 6});
    //

    // console.log("creating random chart", chart);
    // console.log("layers", layer);
    context.commit('mLoading', false);
  } catch(err) {
    console.log(err);
    context.commit('mLoading', false);
  }
  },
  async aAdd (context, chart)  {
    if(typeof chart == "undefined") {
      const num = context.state.charts.length + 1;
      chart = create({
        projectId: context.state.projectId,
        typeGroup: context.state.typeGroup,
        name: context.state.typeGroup + ' ' + num
      });
    }

    delete chart.id;
    chart = await add(chart);

    if(context.state.dataSources.length == 0) {
      let dataSources  = await getDataSources({projectId: context.state.projectId});
      dataSources = dataSources.filter(dd => !dd.parents.length);
      context.commit('mSetDataSources', dataSources);
    }
    // console.log("set tree");
    // chart.setTree(state);
    // chart.loadDataSources();
    // chart.loadDefaultDataSources();
    context.commit('mSet', chart);

    context.commit('mInitializeGrids');
    context.commit('mStartDisplay');

    context.commit('mAdd', chart);
  },
  aImport ({state, commit, rootState, dispatch }, data)  {
    // return download(chart);
  },
  aDownload ({state, commit, rootState, dispatch }, chart)  {
    return download(chart);
  },
  async aUpdate ({state, commit, rootState, dispatch }, chart)  {
    // commit('mLoading', true);
    console.log(chart.id);
    if(isNaN(chart.id)) {
      delete chart.id;
      chart = await add(chart);
    } else {
      await update(chart);
    }

    // const activeLayer = state.activeLayer;
    // if(typeof activeLayer.save != "undefined") {
    //   try {
    //     activeLayer.save();
    //   } catch(error) {

    //   }
    // }


    // commit('mUpdate', chart);
    // commit('mLoading', false);
  },
  async aChanged ({state, commit, rootState, dispatch }, parameter)  {
    state.activeLayer.changed(parameter);
    state.activeLayer.hydrate();
  },
  async aChartChanged ({state, commit, rootState, dispatch }, parameter)  {
    // console.log("aChartChanged", parameter)
    state.chart.changed(parameter);
    // console.log("state.chart", state.chart);
    state.chart.hydrate();
  },
  async aRefresh ({state, commit, rootState, dispatch })  {
    // console.log("tree ", state);
    dispatch('aSet', state.chart, false);
  },
  async aCleanSetByName ({state, commit, rootState, dispatch }, name)  {
    state.filters = {};
    dispatch('aSetByName', name);
  },
  async aCleanSetById ({state, commit, rootState, dispatch }, id)  {
    state.filters = {};
    dispatch('aSetById', id);
  },
  async aSetById ({state, commit, rootState, dispatch }, id, resetFilters)  {
    const chart = state.charts.find(item => item.id == id);
    dispatch('aSet', chart, resetFilters);
  },
  async aSetByName ({state, commit, rootState, dispatch }, name, resetFilters)  {
    const chart = state.charts.find(item => cleanName(item.name) == cleanName(name));
    dispatch('aSet', chart, resetFilters);
  },
  async aCleanSet ({state, commit, rootState, dispatch }, chart)  {
    state.filters = {};
    dispatch('aSet', chart);
  },
  async aLoadFirstTab ({state, commit, rootState, dispatch }, chart)  {

  },
  async aLoadTab ({state, commit, rootState, dispatch }, params)  {
    // await dispatch('aInit');
    // return;
    
    let chart = params.chart;
    let tab = params.tab;

    const dialogParams = chart.getReference("dialogParams");
    const item = chart.getReference("dialogItem");

    // console.log("tab.id", tab.id);

    // alert("aLoadTab 1");

    // console.log('chart.lastItem', chart.references);


   
    const cachedTab = chart.getTab(tab.id);
    if(cachedTab) {
      // console.log("selecta cachedTab", cachedTab.id);
      cachedTab.initialiseGrids(state, item, dialogParams);
      cachedTab.references = chart.references;
      chart.setTab(cachedTab);
      return;
    }
    
 

    chart.setTab(null);
    
    //console.log("aSet chart.id", tab.id);
    //console.log("aSet chart.schemaLoaded", tab.status.schemaLoaded);
   
    if(tab.getLoadedStatus() == false) {
      tab = await getChart(tab.id);
    }
    if(typeof tab.setTree != "undefined") {
      tab.setTree(state);
    }
    if(tab) {
      // console.log('initialiseGrids tab');
      tab.initialiseGrids(state, item, dialogParams);
      tab.references = chart.references;
    }
    
    // console.log("tab ", tab);
    // console.log("chart ", chart);
    // return;

    chart.setTab(tab);
    // alert("aLoadTab 2");
    
    // commit('mLoadChart', chart);
  },
  async aLoadChart ({state, commit, rootState, dispatch }, chart)  {
    // await dispatch('aInit');
    //console.log("aSet chart.id", chart.id);
    //console.log("aSet chart.schemaLoaded", chart.status.schemaLoaded);
   
    if(chart.getLoadedStatus() == false) {
      chart = await getChart(chart.id);
    }
    commit('mLoadChart', chart);
  },
  async aSetSubChart({state, commit, rootState, dispatch }, {chart, item, settings}) {
    // console.log("aSet chart.id", chart.id);

    // if(typeof chart.chartData.expandToPageChart != 'undefined' && chart.chartData.expandToPageChart && typeof chart.chartData.expandToPageChart.initialiseGrids != 'undefined' && chart.chartData.expandToPageChart.initialiseGrids != null) {
    //   // expandToPageChart = true;
    //   chart.chartData.expandToPageChart = 
    // }

    //chart.loadSubChartInDialog(settings, item, function() {
      commit('mSetSubChart', {chart, item, settings});
    //});
    // if(chart.getLoadedStatus() == false) {
    //   chart = await getChart(chart.id);
    // }
    // if(typeof chart.setTree != "undefined") {
    //   chart.setTree(state);
    // }
    // if(chart) {
    //   chart.initialiseGrids(state);
    // }
    
  },
  async aSet ({state, commit }, chart)  {
    // await dispatch('aInit');
    //console.log("aSet chart.id", chart.id);
    //console.log("aSet chart.schemaLoaded", chart.status.schemaLoaded);

    state.loadTime = new Date().toISOString();
   
    if(chart.getLoadedStatus() == false) {
      chart = await getChart(chart.id);
    }
    
    if(state.dataSources.length == 0) {
      let dataSources  = await getDataSources({projectId: state.projectId});
      dataSources = dataSources.filter(dd => !dd.parents.length);
      commit('mSetDataSources', dataSources);
    }
    // chart.setTree(state);
    // chart.initialiseGrids(state);

    // console.log("set tree");
    // chart.setTree(state);
    // chart.loadDataSources();
    // chart.loadDefaultDataSources();
    commit('mSet', chart);

    commit('mInitializeGrids');
    commit('mStartDisplay');
    // console.log("aSet");

    // console.log("aSet", chart);
    //  await update(chart);
    // commit('mUpdate', chart);
    //  commit('mLoading', false);
  },
  async aDelete({state, commit, rootState, dispatch }, element)  {
    await remove(element);
    commit('mDelete', element);
  },
  aCopyGrid({state, commit, rootState, dispatch}, grid) {
      // const lastGrid = state.chart.layout.grids.slice(-1)[0];
      let maxY = Math.max(...state.chart.layout.grids.map(o => o.y+o.h), 0);
      let maxX = Math.max(...state.chart.layout.grids.filter(grid => grid.y+grid.h === maxY).map(o => o.x+o.w), 0);

      if(maxX >= 12) {
        maxX = 0;
      }

      // let g = cloneDeep(grid);
      console.log(grid.getApiInput());
      let inp = JSON.parse(JSON.stringify(grid.getApiInput()));
      let g = createGrid(inp);
      g.id = guid.createId('grid');
      g.i = g.id;

      //const
      //const grid = createGrid({...});

      g.x  = maxX;
      g.y  = maxY;

      g.layout = state.chart.layout;
      commit('mAddGrid', g);
      dispatch('aResized');
    },
  aAddGrid({state, commit, rootState, dispatch}, parameters) {
      // const lastGrid = state.chart.layout.grids.slice(-1)[0];
      let maxY = Math.max(...state.chart.layout.grids.map(o => o.y+o.h), 0);
      let maxX = Math.max(...state.chart.layout.grids.filter(grid => grid.y+grid.h === maxY).map(o => o.x+o.w), 0);

      if(maxX >= 12) {
        maxX = 0;
      }

      if(typeof parameters == "undefined") {
        parameters = {};
      }
      parameters.x = maxX;
      parameters.y = maxY;

      const grid = createGrid(parameters);

      grid.layout = state.chart.layout;
      commit('mAddGrid', grid);
      dispatch('aResized');
    },
    aResized({state, commit, rootState}) {
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    },
    aActivateGrid({state, commit, rootState, dispatch}, grid) {
        commit('mSetActiveGrid', grid);
    },
    aActivateLayer({state, commit, rootState, dispatch}, layer) {
        commit('mSetActiveLayer', layer);
    },
    aRemoveGrid({state, commit, rootState, dispatch}, grid) {
        commit('mRemoveGrid', grid);
    },
    aAddLayer({state, commit, rootState, dispatch}, payload) {

    },
    aRemoveLayer({state, commit, rootState, dispatch}, payload) {
        commit('mRemoveLayer', payload.grid, payload.layer);
    }
};
